import React, { useState, useEffect, useRef } from 'react';
import { IoClose } from 'react-icons/io5';
import './Modal.css';

function Modal({ isOpen, onClose, title, children, onConfirm, confirmText = "Entendido" }) {
    const [isClosing, setIsClosing] = useState(false);
    const closeTimeoutRef = useRef(null);

    useEffect(() => {
        if (isOpen) {
            setIsClosing(false);
            // Clear any pending timeout when opening
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
                closeTimeoutRef.current = null;
            }
        }

        // Cleanup on unmount or when isOpen changes
        return () => {
            if (closeTimeoutRef.current) {
                clearTimeout(closeTimeoutRef.current);
                closeTimeoutRef.current = null;
            }
        };
    }, [isOpen]);

    // Handle Escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && isOpen && !isClosing) {
                handleClose();
            }
        };

        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }

        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, isClosing]);

    if (!isOpen && !isClosing) return null;

    const handleClose = () => {
        if (isClosing) return; // Prevent multiple close triggers
        
        setIsClosing(true);
        closeTimeoutRef.current = setTimeout(() => {
            onClose();
            setIsClosing(false);
            closeTimeoutRef.current = null;
        }, 300); // Match animation duration
    };

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        handleClose();
    };

    return (
        <div 
            className={`modal-overlay ${isClosing ? 'closing' : ''}`} 
            onClick={handleClose}
            role="dialog"
            aria-modal="true"
            aria-labelledby={title ? "modal-title" : undefined}
            aria-label={!title ? "Diálogo" : undefined}
        >
            <div className={`modal-content ${isClosing ? 'closing' : ''}`} onClick={(e) => e.stopPropagation()}>
                <button 
                    className="modal-close" 
                    onClick={handleClose}
                    aria-label="Cerrar diálogo"
                >
                    <IoClose />
                </button>
                {title && <h3 id="modal-title" className="modal-title">{title}</h3>}
                <div className="modal-body">
                    {children}
                </div>
                <button className="modal-button" onClick={handleConfirm}>
                    {confirmText}
                </button>
            </div>
        </div>
    );
}

export default Modal;
